/**
 * Обновить распакованное расширение без «удали и поставь».
 *
 * Магазин Chrome сам не обновляет unpacked. Свой `.crx` обычному человеку
 * поставить нельзя. Что умеем мы: записать файлы нового zip в ту же папку,
 * которую человек один раз указал, и попросить служебный процесс
 * `chrome.runtime.reload()`. Это не снос: `storage.local` (ключ стола,
 * автомат, прогрев) остаётся, куки контор расширение не трогает.
 *
 * Снять расширение — снесёт ключ AdsPower и ступени доверия. Этот модуль
 * карточку из браузера не снимает.
 */

import { unzip } from './unzip';
export { EXT_RELOAD, parseReload, reloadEnvelope } from './reload';

export const KEEP_LOCAL = [
  'forq:desk:cfg',
  'forq:auto:on',
  'forq:auto:cap',
  'forq:auto:tally',
  'forq:warm-on',
  'forq:poly:cap',
] as const;

export function ourManifest(text: string): { version: string; name: string } | null {
  try {
    const body = JSON.parse(text) as { name?: unknown; version?: unknown };
    if (typeof body.name !== 'string' || !body.name.includes('FORQ') || body.name.includes('проверка коэффициентов')) return null;
    if (typeof body.version !== 'string' || !/^\d+\.\d+(?:\.\d+){0,2}$/.test(body.version)) return null;
    return { version: body.version, name: body.name };
  } catch {
    return null;
  }
}

/** Входящая свежее стоящей. Равные и ниже — не пишем, не откатываем. */
export function newerThan(have: string | null, incoming: string): boolean {
  if (have === null || have === '') return true;
  const a = have.split('.').map((n) => Number.parseInt(n, 10) || 0);
  const b = incoming.split('.').map((n) => Number.parseInt(n, 10) || 0);
  const len = Math.max(a.length, b.length);
  for (let i = 0; i < len; i += 1) {
    const x = a[i] ?? 0;
    const y = b[i] ?? 0;
    if (y > x) return true;
    if (y < x) return false;
  }
  return false;
}

export async function packOf(buf: ArrayBuffer): Promise<{ version: string; files: Map<string, Uint8Array> }> {
  const files = await unzip(buf);
  const raw = files.get('manifest.json');
  if (raw === undefined) throw new Error('в архиве нет manifest.json');
  const man = ourManifest(new TextDecoder().decode(raw));
  if (man === null) throw new Error('это не архив FORQ');
  return { version: man.version, files };
}

export function folderOurs(manifestText: string): boolean {
  return ourManifest(manifestText) !== null;
}

export const WALL =
  'укажите папку уже установленного FORQ один раз — запишем туда новый архив и перечитаем. снимать расширение нельзя: слетит ключ стола.';

export const AFTER_WRITE =
  'Файлы обновлены. Обновите вкладку FORQ для проверки версии; карточку не снимайте — настройки сохранятся.';

/**
 * Стена магазина. Публикацию жмёт только владелец: developer.chrome.com →
 * карточка FORQ → Upload new package → zip с forq.ru/forq-extension.zip →
 * «Отправить на проверку». Пока модерация идёт, люди остаются на нашем пути
 * (папка + одно нажатие). Unpacked магазин сам не везёт — «обновилось само»
 * из CWS не рисуем.
 */
export const STORE_OWNER =
  'Публикацию в Chrome Web Store жму только я. Когда распакованный путь уже живёт у тестеров и версия в forq-extension.json — та, что поедет в магазин, открываю developer.chrome.com/webstore/devconsole → карточка FORQ → Upload new package → тот же https://forq.ru/forq-extension.zip → Отправить на проверку. Пока модерация идёт, люди обновляются с сайта: одно нажатие, папка та же, карточку не снимают. Зелёную кнопку «обновилось само» из магазина не рисуем: unpacked он не везёт.';
